const en = {
  listTitle: 'All workflows',
  addButton: 'Add a workflow',
  lastUpdated: 'Modifié le',
}

export default en
export type Translations = typeof en
